import { render, staticRenderFns } from "./Tournament2026.vue?vue&type=template&id=315449f9&scoped=true"
import script from "./Tournament2026.vue?vue&type=script&lang=js"
export * from "./Tournament2026.vue?vue&type=script&lang=js"
import style0 from "./Tournament2026.vue?vue&type=style&index=0&id=315449f9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315449f9",
  null
  
)

export default component.exports